import React from 'react';

import {Modal, ModalHeader, ModalBody, ModalFooter} from 'Components/Modal';
import {Alert} from 'Components/Partials';
import {FormHandler, Input, FileUpload} from 'Components/Form';
import {PrimaryButton} from 'Components/Button';

import CarouselItemApi from 'Services/Api/Exhibitor/CarouselItem';

class UpdateCarouselItem extends React.Component {
    /**
     * @var success
     * @type {string}
     */
    success = 'Your carousel items have been updated';

    /**
     * @method componentDidMount
     */
    componentDidMount = async () => {
        const {setForm, carouselItem} = this.props;

        let form = {};

        if (carouselItem) {
            form = {
                ...carouselItem
            };
        } else {
            form = {
                title: '',
                thumbnail: null,
                src: '',
            };
        }

        setForm(form);
    }

    /**
     * @method handleSubmit
     * @param {Event} e
     */
    handleSubmit = async (e) => {
        e.preventDefault();

        const {form, setAlert, setWorking, exhibitor, carouselItem, submitCallback} = this.props;

        setWorking(true);

        let response = null;

        if (carouselItem) {
            response = await CarouselItemApi.updateCarouselItem(carouselItem.id, form);
        } else {
            response = await CarouselItemApi.storeCarouselItem({
                ...form,
                exhibitor_id: exhibitor.id
            });
        }

        if (!response.success) {
            setAlert('error', response.message, response.errors);
            setWorking(false);
            return false;
        } else {
            setAlert('success', this.success, {});
            submitCallback();
            this.props.onClose();
        }
    };

    /**
     * @method handleDelete
     */
    handleDelete = async () => {
        const {setAlert, setWorking, carouselItem, submitCallback} = this.props;

        setWorking(true);

        let response = await CarouselItemApi.delete(carouselItem.id);

        setAlert('success', 'Item deleted', {});
        setWorking(false);

        submitCallback();

        this.props.onClose();
    };

    /**
     * @method render
     * @return {JSX.Element}
     */
    render () {
        const {form, handleInput, getFieldError, alert, working, carouselItem} = this.props;

        return (
            <Modal>
                <ModalHeader onClose={this.props.onClose}>
                    {carouselItem ? 'Update' : 'Submit'} your carousel item
                </ModalHeader>

                <form onSubmit={e => this.handleSubmit(e)}>
                    <ModalBody>
                        {alert && (<Alert {...alert} />)}

                        <Input
                            containerClassName="my-4"
                            label="Title"
                            type="text"
                            value={form.title}
                            error={getFieldError('title')}
                            onChange={v => handleInput('title', v)}
                        />

                        <FileUpload
                            containerClassName="my-4"
                            label="Thumbnail"
                            value={form.thumbnail}
                            error={getFieldError('thumbnail')}
                            onChange={v => handleInput('thumbnail', v)}
                            accept='image/*'
                            placeholder={carouselItem ? 'Update file' : 'Select file'}
                        />

                        <Input
                            containerClassName="my-4"
                            label="URL Link (Please include https://)"
                            type="text"
                            value={form.src}
                            error={getFieldError('src')}
                            onChange={v => handleInput('src', v)}
                        />
                    </ModalBody>

                    <ModalFooter alignment="center">
                        <PrimaryButton
                            text="Close"
                            onClick={this.props.onClose}
                            className="mr-2"
                        />

                        {carouselItem &&
                            <PrimaryButton
                                className="ml-2"
                                text="Delete"
                                onClick={this.handleDelete}
                                disabled={working}
                                working={working}
                            />
                        }

                        <PrimaryButton
                            className="ml-2"
                            text={carouselItem ? 'Update' : 'Submit'}
                            disabled={working}
                            working={working}
                        />
                    </ModalFooter>
                </form>
            </Modal>
        )
    }
}

export default FormHandler(UpdateCarouselItem);
